export const MAX_MATCHES_DISPLAYED = 1000;
